'use client';

import React, { memo, PropsWithChildren } from 'react';

import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@repo/ui/components/ui/drawer';

import { YtVideoCardAnalysisContent } from './yt-video-card-analysis-content';
import { useYtVideoCardAnalysis } from './yt-video-card-analysis-intent-context';

interface YtVideoCardAnalysisBottomSheetProps extends PropsWithChildren {
  open: boolean;
  setOpen: (open: boolean) => void;
  videoId: string;
}

const PureYtVideoCardAnalysisBottomSheet: React.FC<
  YtVideoCardAnalysisBottomSheetProps
> = ({ children, open, setOpen, videoId }) => {
  const { intent } = useYtVideoCardAnalysis();

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>{children}</DrawerTrigger>
      <DrawerContent className="size-full dark bg-black p-0 text-sidebar-foreground space-y-2 data-[vaul-drawer-direction=bottom]:max-h-dvh [&>div:first-child]:bg-[#c0c0c0]">
        <div
          id="article-card-analysis-bottom-sheet"
          className="flex-1 overflow-y-auto text-white overscroll-none"
        >
          <DrawerHeader className="sr-only bg-transparent">
            <DrawerTitle>Article Analysis</DrawerTitle>
            <DrawerDescription>
              Displays the article analysis sidebar.
            </DrawerDescription>
          </DrawerHeader>
          <YtVideoCardAnalysisContent videoId={videoId} intent={intent} />
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export const YtVideoCardAnalysisBottomSheet = memo(
  PureYtVideoCardAnalysisBottomSheet,
);
